/**
 * @file The Purchase Album component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { Redirect } from 'react-router-dom';

import PurchaseAlbumHeaderContainer from '../../containers/purchase/PurchaseAlbumHeaderContainer';
import PurchaseAlbumPpaInfo from './PurchaseAlbumPpaInfo';
import PurchasePpdPhotosContainer from '../../containers/purchase/PurchasePpdPhotosContainer';
import { hasFolderSubscription, isPpa } from '../../util/album';
import Spinner from '../global/Spinner';
import { shouldDisplayBrandAttribution } from '../../util/ppd-purchase';
import PhotographerAttributionBanner from '../discover/PhotographerAttributionBanner';
import PurchaseAlbumSendPurchaseLink from './PurchaseAlbumSendPurchaseLink';

class PurchaseAlbum extends Component {
  static propTypes = {
    album: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      display_name: PropTypes.string,
      is_demo: PropTypes.bool.isRequired,
      price_whole_album: PropTypes.shape({
        value: PropTypes.number,
      }),
      photo_pricing: PropTypes.shape({
        id: PropTypes.string,
      }),
      album_print_packages: PropTypes.shape({
        total: PropTypes.number,
      }),
    }),
    albumMembership: PropTypes.shape({
      id: PropTypes.string,
    }),
    match: PropTypes.shape({
      url: PropTypes.string,
    }),
    loading: PropTypes.bool,
    user: PropTypes.shape({
      id: PropTypes.string,
    }),
    loadingAlbum: PropTypes.bool,
  };

  render() {
    const { album, albumMembership, match, loading, user, loadingAlbum } =
      this.props;
    const albumId = get(album, 'id');

    if (loading || loadingAlbum) {
      return (
        <div className="d-flex min-h-100vh align-items-center justify-content-center">
          <Spinner />
        </div>
      );
    }

    if (!loading && !albumMembership && user) {
      return <Redirect to={`/purchase/album/${albumId}/faces`} />;
    }

    return (
      <div className="wrapper-main min-h-100vh">
        <PurchaseAlbumHeaderContainer album={album} />
        {shouldDisplayBrandAttribution(album) && (
          <PhotographerAttributionBanner account={album.creator} />
        )}
        <PurchaseAlbumSendPurchaseLink
          album={album}
          user={user}
          className="text-sm m-auto py-1"
        />
        {
          // If the user is already joined send them to photo
          // purchase (i.e. obfuscated matched photos) view, otherwise
          // begin joining flow
          albumMembership ? (
            <PurchasePpdPhotosContainer
              album={album}
              albumMembershipId={albumMembership.id}
              match={match}
              hasPpaMode={isPpa(album)}
              hasFolderSubscription={hasFolderSubscription(album)}
            />
          ) : (
            <PurchaseAlbumPpaInfo album={album} />
          )
        }
      </div>
    );
  }
}

export default PurchaseAlbum;
